export default "__VITE_ASSET__BhOduT7B__"